import { AudioDevice } from "@/types/audio/audio";
import { ActiveMapItem } from "../site-monitor/types";

export interface SiteMonitorCamerasState {
	layoutIndex: number;
	layouts: number[][];
	userLastLayoutIndex: number | null;
	matrixContents: MatrixContents;
	matrixPushContents: MatrixContents;
	mediaMatrixCameras: any[];
	mediaMatrixClips: any[];
	mediaMatrixLayers: any[];
	areaCameras: CameraType[];
	deviceControllerCameras: any[];
	deviceControllerOutputs: any[];
	deviceControllerAudioDevices: ActiveMapItem[];
	deviceControllerClips: any[];
	mediaMatrixIsNew: boolean;
	fetchingMatrix: boolean;
	mediaMatrixFilter: string;
	mediaMatrixEventId: number | null;
	awaitingCamera: any;
	awaitingClip: any;
	linkRecord: any;
	saveLink: boolean;
	requiresEventDetails: boolean;
	highlightCellIndices: number[];
	mediaMatrixLastChanged: number;
	waitingForEvent: boolean;
	searchedCameras: any[];
	searchedOutputs: any[];
	shownAuditClips: string[];
	areaOutputs: DeviceControllerOutput[];
	areaOutputCount: number;
	areaCameraCount: number;
	searchedCameraCount: number;
	searchedGroupCameraCount: number;
	searchedOutputCount: number;
	areaAudioDevices: AudioDevice[];
	areaAudioDevicesCount: number;
	nearbyAudioDevices: AudioDevice[];
	filteredAreaAudioDevicesCount: number;
}

export interface LinkedCamera {
	deviceID: number;
	title: string;
}

export interface MatrixContents {
	[key: number]: {
		camera?: MatrixCamera;
		clip?: MatrixClip;
	};
}

export interface MatrixCamera {
	objectID: number;
	title: string;
	index: number;
}

export interface ClipType {
	active: boolean;
	clip?: ClipType;
	CreatedGroupTimezone?: string;
	CreatedUTC: string;
	DeviceId?: number;
	DeviceTitle: string;
	Error?: string;
	EventRecordId: number;
	FileIdentifier: string;
	FileSize: number;
	FileSizeError: boolean;
	FriendlyStartTime?: string;
	index?: number;
	MediaType: string;
	StartTime?: Date;
	Subtitle: string;
	title: string;
	UniqueFileIdentifier: string;
	// Duplicate-clip grouping (Media Matrix). Sourced from SVAudit on every listing path.
	AutomationId?: number | null;
	DuplicateCount?: number;
	/** Tri-state completion status: true = partial, false = complete, null/undefined = unknown. */
	IsPartial?: boolean | null;
}

export interface ClipClipType {
	clip: ClipType;
	eventRecordID: number;
}

// A record automation's clips grouped into a single clip-list row (Media Matrix
// duplicate-clip handling, US2). See ClipsList.displayGroups.
export interface ClipGroup {
	best: ClipType;
	members: ClipType[];
	hasDuplicates: boolean;
	groupKey: string | null;
	expanded: boolean;
}

// A ClipGroup enriched with the display-only fields the clip list renders per row.
export interface ClipDisplayGroup extends ClipGroup {
	representative: ClipType;
	dupCount: number;
	countLabel: string;
	plottedCells: number[];
	showPartial: boolean;
	attemptOf: { [id: string]: number };
	attemptTotal: number;
}

export interface MultipleClipsIndex {
	indexes: number[]
}

export interface CameraType {
	title: string;
	distance: number;
	deviceID: number;
	objectID: number;

	active?: boolean;
	index?: any;
	layoutIndex?: any;
	lastError?: string;
	lastInteractionHealthy?: boolean;
}

export interface NearbyCameraType {
	distance: number;
	itemType: number;
	objectId: number;
	title: string;
	index?: any;
}

export interface MatrixClip {
	clip: {
		FileIdentifier: string;
		index?: any;
		UniqueFileIdentifier: string;
	};
	eventRecordID: number;
}

/* interface mapItemType {
  extraValue: string;
  latLong: string;
  mapLayerItemId: number;
  mapLayerItemTypeId: number;
  maxElevation: number;
  minElevation: number;
  objectID: number;
  regionPath: string;
  title: string;

  active?: boolean;
  index?: any;
  layoutIndex?: any;
} */

export interface  DeviceControllerOutput {
	controlRequest: boolean;
	controlReason: string;
	controlError: string;
	sendingCommand: boolean;
	distance: number;
	imperial: boolean;
	deviceTypeID: number;
	objectId: number;
	title: string;
	isOutput: boolean;
	canPulse: boolean,
	canOnOff: boolean,
}

export interface SearchedCamera {
	areaTitle: string;
	distance?: string;
	imperial?: boolean;
	index: number;
	itemType: number;
	objectID: number;
	title: string;
}

export interface ClipEmitObject {
	eventRecordID: number;
	cameras: any[];
	newClips:any[]
}

export function defaultDeviceControllerOutput(): DeviceControllerOutput {
	return {
		controlRequest: false,
		controlReason: "",
		controlError: "",
		sendingCommand: false,
		distance: null,
		imperial: null,
		deviceTypeID: null,
		objectId: null,
		title: "",
		isOutput: false,
		canPulse: false,
		canOnOff: false
	};
}

export interface MatrixContentItem {
	camera?: MatrixCamera;
	clip?: ClipType | ClipClipType;
}
